<template>
  <div class="el-collapse-item">
    <div role="tab">
      <div role="button" tabindex="0" class="el-collapse-item__header" @click="toggle()">
        <span class="el-collapse-item__header-title">
          <slot name="title"></slot>
        </span>
        <span v-show="!disabled">
          <el-tag type="success">Scheduled</el-tag>
          <el-tag type="info">Off</el-tag>
        </span>
        <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
      </div>
    </div>
    <div role="tabpanel" aria-hidden="true" class="el-collapse-item__wrap" v-show="open">
      <div class="el-collapse-item__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElCollapseItem',
  props: ['icon', 'name', 'title', 'disabled', 'actions'],
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables';

.el-collapse-item {
  &__header-title{
    font:{
      weight: bold;
      size: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ElCollapseItem.vue